import React from 'react';
import { inject, observer } from 'mobx-react';
import { BoxTemplate } from '../styledSystem/Box';
import { Header2 } from '../styledSystem/Text';

class Error extends React.Component {
    render() {
        return (
            <BoxTemplate textalign="center">
                <img
                    src={require('../assets/close-circle-outline.png')}
                    alt="error"
                />
                <Header2>Error</Header2>
                <Header2>Ups... Something went wrong!</Header2>
            </BoxTemplate>
        );
    }
}

export default inject('session')(observer(Error));



// WEBPACK FOOTER //
// ./src/pages/Error.js